import React from 'react';
import './SocialIcon.css';
import pdfUrl from './ebio-narduche-full-stack.pdf';

const Curriculum = () => {
    const openPDF = () => {
        window.open(pdfUrl, '_blank');
    };

    return (
        <div className="social-icon-container" onClick={openPDF}>
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 64 64" width="40px" height="40px">
                <path d="M 13 7 L 13 59 L 30.136719 49.980469 C 31.302719 49.366469 32.697281 49.366469 33.863281 49.980469 L 51 59 L 51 46.71875 C 50.027 46.89775 49.026 47 48 47 C 39.163 47 32 40.06 32 31.5 C 32 22.94 39.163 16 48 16 C 49.026 16 50.027 16.10225 51 16.28125 L 51 7 L 13 7 z M 48 18 C 40.82 18 35 23.82 35 31 C 35 38.18 40.82 44 48 44 C 55.18 44 61 38.18 61 31 C 61 23.82 55.18 18 48 18 z M 47 24 L 49 24 L 50 29 L 55 30 L 55 32 L 50 33 L 49 38 L 47 38 L 46 33 L 41 32 L 41 30 L 46 29 L 47 24 z"
                    className='social-icon'
                    fill='white'
                />
            </svg>
        </div>
    );
};

export default Curriculum;
